import { atom, useRecoilState, useRecoilValue } from 'recoil';
import { dimensionsAtom } from 'pages/dimensions/store/dimensions';
import { useContext } from 'react';
import { getTotalCostComplimentaryProducts } from 'common/helpers/get-total-cost-complimentary-products.helper';
import { DataContext } from '../../../entries/common/widgets/context';
import { getPrice } from '../../../common/helpers/get-price.helper';
import { getTintPrice } from '../helpers/get-tint-price.helper';
import { tintServiceIsAnyColorsSelected } from './tint-service';

const defaultValues = {
  count: '',
  addToCartIsSuccessful: false,
};

export const calculationState = atom({
  key: 'calculation',
  default: defaultValues,
});

export const ZERO_PRICE = 0;

export const useCalculationState = () => {
  const remoteData = useContext(DataContext);

  const dimensions = useRecoilValue(dimensionsAtom);
  const [calculationFormState, setCalculationState] = useRecoilState(calculationState);
  const { items, complimentaryProductInfo, checkedProducts } = dimensions;
  const isAnyColorsSelected = useRecoilValue(tintServiceIsAnyColorsSelected);
  const tintPrice =
    getTintPrice({ volume: remoteData?.weight, count: calculationFormState.count }) ?? ZERO_PRICE;
  const totalTintPrice = isAnyColorsSelected ? tintPrice : ZERO_PRICE;

  const totalPriceOfComplimentaryProducts = complimentaryProductInfo.length
    ? getTotalCostComplimentaryProducts({ complimentaryProductInfo, checkedProducts })
    : 0;

  const calculatedPrice = remoteData
    ? getPrice({
        mainPrice: remoteData.mainPrice,
        numberOfItemsInStringFormat: calculationFormState.count,
        additionalAsMain: remoteData?.additionalAsMain,
        additionalPrice: remoteData.additionalPrice,
      })
    : ZERO_PRICE;

  const totalAmount = calculatedPrice + totalPriceOfComplimentaryProducts + totalTintPrice;

  const {
    total: { requiredQuantity },
  } = items[0];
  if (!calculationFormState.count && requiredQuantity) {
    setCalculationState(prevState => ({
      ...prevState,
      count: requiredQuantity.toString(),
    }));
  }

  return {
    calculationFormState,
    setCalculationState,
    calculatedPrice,
    totalAmount,
  };
};
